import React from 'react';
import "./CustomMessage.scss"

const CustomMessage = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="custom-confirm-dialog">
      <center><p style={{margin:15 , fontSize:18} }>{message}</p></center>
      <div className='buttons_container'>
        {onCancel &&
          <button  onClick={onCancel}>Close</button>
        }
        {onConfirm &&
          <button  onClick={onConfirm}>Ok</button>
        }
      </div>
    </div>
  );
};

export default CustomMessage;